<template>
  <ExternalQueryList
      headline="Sitemap Links"
      endpoint="/api/v2/sitemap-links"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      reorder-endpoint="/api/v2/sitemap-links/priorities"
      :get-reorder-payload="data => ({sitemap_links: data})"
      @show="sitemapLink => $router.push(getUrl(sitemapLink))"
  >
    <template v-slot:default="{ row: sitemapLink }">
      <td>
        <router-link :to="getUrl(sitemapLink)">
          {{ sitemapLink.attributes.text }}
        </router-link>
      </td>

      <td>
        {{ sitemapLink.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/sitemap-links/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Text'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(sitemapLink) {
      return '/portals/' + this.portal.id + '/content/sitemap-links/' + sitemapLink.id + '/edit'
    }
  }
}
</script>
